(function () {
  'use strict';
  if (window.__spQA == null) window.__spQA = (function () { var q = /[?&]sp_qa=([01])(?:&|$)/.exec(location.search), s = false; try { if (q) localStorage.setItem('sp_qa', q[1]); s = localStorage.getItem('sp_qa') === '1'; } catch (e) {} var r = window.Shopify && window.Shopify.theme && window.Shopify.theme.role; return s || /^(localhost|127\.0\.0\.1)$/.test(location.hostname) || /SimplePaperQA/.test(navigator.userAgent) || (!!r && r !== 'main'); })();
  if (window.__spBreadcrumbTracking) return;
  window.__spBreadcrumbTracking = true;

  var PAGE_TYPE = (document.body.className.match(/\btemplate-([a-z0-9-]+)/) || [, 'unknown'])[1];
  var queue = [];
  var consent = null; // null = unknown, then true/false

  function allowed() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.analyticsProcessingAllowed !== 'function') return null;
      return !!api.analyticsProcessingAllowed();
    } catch (e) { return null; }
  }

  function deliver(name, props) {
    if (window.__spQA) return;
    try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, props); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, props); } catch (e) {}
  }

  function send(name, props) {
    if (consent === true) { deliver(name, props); return; }
    if (consent === false) return;
    if (queue.length < 20) queue.push([name, props]);
  }

  function settle() {
    var a = allowed();
    if (a === null) return;
    consent = a;
    if (a) queue.forEach(function (q) { deliver(q[0], q[1]); });
    queue.length = 0;
  }
  settle();
  document.addEventListener('visitorConsentCollected', settle);
  window.setTimeout(settle, 1200);
  window.setTimeout(function () { if (consent === null) { consent = false; queue.length = 0; } }, 8000);

  // Capture phase: the click navigates away, and gtag/PostHog both flush with
  // sendBeacon on pagehide, so recording it before the default action is enough.
  document.addEventListener('click', function (ev) {
    var link = ev.target.closest && ev.target.closest('.breadcrumbs-list__link');
    if (!link) return;
    var items = Array.prototype.slice.call(link.closest('.breadcrumbs-list').querySelectorAll(':scope > .breadcrumbs-list__item'))
      .filter(function (li) { return li.querySelector('.breadcrumbs-list__link'); });
    var level = items.indexOf(link.closest('.breadcrumbs-list__item')) + 1;
    if (level < 1) return;
    var target = '';
    try { target = new URL(link.href, location.href).pathname; } catch (e) {}
    send('sp_breadcrumb_click', {
      level: level,
      depth: items.length,
      levels_up: items.length - level,
      target: target,
      label: (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60),
      page_type: PAGE_TYPE
    });
  }, true);
})();
